import { render, staticRenderFns } from "./AnomalyReports.vue?vue&type=template&id=31fc3392&scoped=true"
import script from "./AnomalyReports.vue?vue&type=script&lang=js"
export * from "./AnomalyReports.vue?vue&type=script&lang=js"
import style0 from "./AnomalyReports.vue?vue&type=style&index=0&id=31fc3392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc3392",
  null
  
)

export default component.exports